var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 7.6a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8zm0 3.2a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8zM6 8a.4.4 0 1 0 .4.4A.4.4 0 0 0 6 8zm2.4 5.6a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4zM6 11.2a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4zm2.4-4.8A.4.4 0 1 0 8 6a.4.4 0 0 0 .4.4zm3.2 1.2a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8zm0-1.2a.4.4 0 1 0-.4-.4.4.4 0 0 0 .4.4zm2.4 4.8a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4zM14 8a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4zm-4-6a8 8 0 1 0 8 8 8 8 0 0 0-8-8zm0 14.4a6.4 6.4 0 1 1 6.4-6.4 6.4 6.4 0 0 1-6.4 6.4zm1.6-2.8a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4zm0-2.8a.8.8 0 1 0 .8.8.8.8 0 0 0-.8-.8z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#9e9e9e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrand);
export default __webpack_public_path__ + "static/media/icon-trand.44188ca1.svg";
export { ForwardRef as ReactComponent };